<template>
  <section class="rikisha-grid-section">
    <div class="rikisha-grid-container">
      <div
        class="rikisha-grid__section-inner"
        :class="{ 'reverse-layout': shopifyData.layout === 'right' }"
      >
        <div
          class="rikisha-grid__section-left"
          :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
        >
          <div class="rikisha-grid__scrollingtext">
            <h2 class="rikisha-grid__heading">
              {{ shopifyData.sectionTitle }}
            </h2>

            <h2 class="rikisha-grid__heading--res">
              {{ shopifyData.sectionTitle }}
            </h2>
            <a :href="shopifyData.buttonLink" class="rikisha-grid__button">
              {{ shopifyData.buttonLabel }}
            </a>
          </div>
        </div>
        <div class="rikisha-grid__secondary-image">
          <img
            :src="shopifyData.desktopRightBg"
            :alt="shopifyData.desktopRightBg.altText"
            class="rikisha-grid__secondary-image-img"
            loading="lazy"
            aria-hidden="true"
            aria-label="Desktop Right Background"
            width=""
            height=""
          />
        </div>
      </div>

      <div
        class="rikisha-grid__content rikisha-grid__content--grid"
        :class="{ 'rikisha-grid__layout--reverse': shopifyData.layout === 'right' }"
      >
        <div />
        <div class="rikisha-grid__rightside">
          <div style="height: fit-content">
            <div class="rikisha-grid__scrollingtext--res-section">
              <h2 class="rikisha-grid__heading--res-section">
                {{ shopifyData.sectionTitle }}
              </h2>
              <a :href="shopifyData.buttonLink" class="rikisha-grid__button--res-section">{{
                shopifyData.buttonLabel
              }}</a>
            </div>
          </div>
          <!-- Right Grid Part  -->
          <div class="rikisha-grid__products">
            <div v-for="(value, key) in shopifyData.productData" :key="key" class="grid_item">
              <a
                :href="value.product.productUrl"
                :product-id="value.product.productid"
                class="rikisha-grid__product-link"
              >
                <div class="rikisha-grid__img">
                  <img
                    v-lazy="
                      value.showPreview == 'true'
                        ? value.previewimage
                        : value.product.productidImage
                    "
                    :alt="value.showPreview == 'true' ? 'Preview Image' : 'Product Image'"
                    loading="lazy"
                    aria-hidden="true"
                    aria-label="Product Image"
                    width=""
                    height=""
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      backgroundImage: this.shopifyData.desktopLeftBg,
    };
  },
  mounted() {
    this.updateBackgroundImage();

    // Add a resize event listener
    window.addEventListener('resize', this.updateBackgroundImage);

    //Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    function animateSection(section) {
      ScrollTrigger.matchMedia({
        '(min-width: 769px)'() {
          gsap
            .timeline({
              scrollTrigger: {
                trigger: section.querySelector('.rikisha-grid__section-inner'),
                scrub: 2,
                start: 'top top',
                end: '100% center',
              },
            })
            .to(
              section.querySelector('.rikisha-grid__section-inner'),
              {
                position: 'sticky',
                top: 0,
              },
              'b'
            );
        },
        '(max-width: 768px)'() {
          // console.log("this is on Mobile");
          gsap
            .timeline({
              scrollTrigger: {
                trigger: section.querySelector('.rikisha-grid__section-left'),
                start: '20% 20%',
                end: 'bottom -100%',
                scrub: true,
                //   markers:true
              },
            })
            .fromTo(
              section.querySelector('.rikisha-grid__section-left'),
              {
                backgroundSize: '150%',
              },
              {
                backgroundSize: '100%',
              }
            );
        },
        all() {
          ScrollTrigger.refresh();
        },
      });
    }

    // Apply animation to each section
    document.querySelectorAll('.rikisha-grid-container').forEach((section) => {
      animateSection(section);
    });
  },
  beforeUnmount() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateBackgroundImage);
  },
  methods: {
    updateBackgroundImage() {
      if (window.innerWidth <= 676) {
        this.backgroundImage = this.shopifyData.mobBannerBg;
      } else {
        this.backgroundImage = this.shopifyData.desktopLeftBg;
      }
    },
  },
};
</script>

<style scoped>
.rikisha-grid__heading {
  color: white;
  text-wrap: nowrap;
  padding-top: 30%;
  font-size: 57px;
  font-style: italic;
  font-weight: 200;
  line-height: 1.43;
  text-align: center;
  font-family: 'PP Editorial New', sans-serif;
  /* Updated */
}

.rikisha-grid__img img {
  display: block;
}

.rikisha-grid__products {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  backdrop-filter: blur(100px);
  background-image: linear-gradient(rgb(240 241 244), rgb(240 241 244));
  background-color: #f0f1f4;
}

.rikisha-grid__products img {
  width: 100%;
  height: 100%;
}

.secleft {
  position: relative;
}

.rikisha-grid__button {
  color: #fff;
  font-family:
    Helvetica Neue,
    sans-serif;
  font-size: 14.99px;
  font-weight: 700;
  line-height: 13.64px;
  letter-spacing: 0.11em;
  text-align: center;
  text-wrap: nowrap;
  display: block;
}

.rikisha-grid__section-inner {
  position: relative;
}

.rikisha-grid-container .rikisha-grid__section-inner {
  display: flex;
  flex-direction: row;
}

.rikisha-grid__layout--reverse .rikisha-grid__rightside {
  grid-column-start: 1;
  grid-column-end: 2;
}

.rikisha-grid-container .rikisha-grid__section-inner.reverse-layout {
  flex-direction: row-reverse;
}

.rikisha-grid__section-left {
  height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left;
}

.rikisha-grid-container .rikisha-grid__section-left {
  max-width: 50%;
}

.rikisha-grid-container .rikisha-grid__secondary-image {
  max-width: 50%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rikisha-grid__secondary-image img {
  display: block;
}

.rikisha-grid__heading--res {
  display: none;
}

.rikisha-grid__content--grid {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  position: relative;
  z-index: 2;
}

.rikisha-grid__scrollingtext {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  width: 50%;
  height: 100vh;
  margin: 0 auto;
}

.scrollingtext {
  display: flex;
}

.rikisha-grid__scrollingtext--res-section {
  display: none;
}

@media only screen and (max-width: 1150px) {
  .rikisha-grid__heading {
    font-size: 34px;
    line-height: 1.9;
  }

  .rikisha-grid__button {
    font-size: 14px;
  }
}

@media only screen and (max-width: 1024px) {
  .heading-text,
  .heading-text-bottom,
  .rikisha-grid__heading,
  .rikisha-grid__button {
    text-align: center;
  }
}

@media only screen and (max-width: 768px) {
  .rikisha-grid__section-left {
    height: 100vh;
    width: 100%;
    max-width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
  }

  .rikisha-grid__layout--reverse .rikisha-grid__rightside {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  .rikisha-grid-container .rikisha-grid__section-left {
    max-width: 100%;
  }

  .rikisha-grid-container .rikisha-grid__secondary-image {
    display: none;
  }

  .scrollingtext {
    display: none;
  }

  .rikisha-grid__heading--res-section {
    padding-bottom: 134px;
    font-size: 30px;
    font-style: italic;
    font-weight: 200;
    line-height: 0.9;
    text-align: center;
    font-family: 'PP Editorial New', sans-serif;
    /* Updated */
  }

  .rikisha-grid__button--res-section {
    font-family:
      Helvetica Neue,
      sans-serif;
    font-size: 14.99px;
    font-weight: 700;
    line-height: 13.64px;
    letter-spacing: 0.11em;
    text-align: center;
    color: #fff;
  }

  .rikisha-grid__scrollingtext--res-section {
    display: flex;
    flex-direction: column;
    gap: 123px;
    position: relative;
    z-index: 9;
    color: #ffffff;
    padding-bottom: 45px;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-right: 13px;
    padding-left: 14px;
  }

  .rikisha-grid__heading--res {
    display: block;
    font-size: 34px;
    line-height: 60px;
    font-weight: 400;
    color: #fff;
    text-wrap: nowrap;
    padding-top: 30%;
  }

  .rikisha-grid__section-inner {
    position: sticky;
    top: 0;
  }

  .rikisha-grid__scrollingtext {
    display: none;
    justify-content: end;
    height: 98vh;
    margin: 0 auto;
    gap: 40%;
  }

  .rikisha-grid__content--grid {
    grid-template-columns: 0% 100%;
  }

  .rikisha-grid__products {
    width: 100%;
    transform: translateX(0);
  }

  .rikisha-grid__heading {
    display: none;
    text-align: center;
    font-size: 36px;
    text-wrap: nowrap;
  }

  .rikisha-grid__button {
    text-align: center;
    font-size: 15px;
    color: #fff;
  }
}

@media only screen and (max-width: 340px) {
  .rikisha-grid__heading--res-section {
    font-size: 26px;
  }
}
</style>
